import React, { Component, useEffect, useState } from "react";
import styled from "styled-components";
import desktopBackground from "../../assets/images/desktopBackground.png";
import closepayLogo from "../../assets/images/closepayLogo.png";
import bsi from "../../assets/images/bsi.png";
import * as API from "../../core/service/api.js";
import {} from "../../core/feature/store";
import { useAppSelector, useAppDispatch } from "../../core/feature/hooks";
import {
  removeCompany,
  setCompany,
} from "../../core/feature/company/companySlice";

import Company from "../../core/models/company";
import { Link, useNavigate } from "react-router-dom";
import { setLoading } from "../../core/feature/config/configSlice";
import { BrowserView, MobileView } from "react-device-detect";
import CalendarWeb from "./calendarWeb";
import CalendarMobile from "./calendarMobile";
import useAnalyticsEventTracker from "../../core/service/useAnalyticsEventTracker";
import ReactGA from "react-ga4";

const CalendarComponent = () => {
  useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: window.location.pathname + window.location.search,
      title: "Calendar Academic",
    });
  }, []);
  return (
    <>
      <BrowserView>
        <CalendarWeb></CalendarWeb>
      </BrowserView>
      <MobileView>
        <CalendarMobile></CalendarMobile>
      </MobileView>
    </>
  );
};

export default CalendarComponent;
